import { getGlobalLookup } from "../deprecated/lookup";

// Route through getGlobalLookup so that SSR request-scoped lookups
// (see @faire/next-utils/initializers/clientComponentSSR) are honored.
export const getWindow = (): (Window & typeof globalThis) | undefined =>
  getGlobalLookup()<Window & typeof globalThis>("window");

export const getWindowOrThrow = (): Window & typeof globalThis => {
  const window = getWindow();
  if (!window) {
    throw new Error("Could not find global window");
  }
  return window;
};
